export default "__VITE_ASSET__8a2ec1a4__"